var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isHidden)?_c('v-img',_vm._b({on:{"error":function($event){return _vm.$emit('error', $event)}}},'v-img',_vm.imageProps,false),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }